import { useNavigate, useLocation } from "react-router-dom";
import { back } from "../asset";

interface PageHeaderProps {
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
}

export default function PageHeader({
  title,
  showBack = false,
  onBack,
}: PageHeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;

  // if last part is a number, take the previous segment
  const pathSegments = currentPath.split("/").filter(Boolean);
  const lastSegment =
    isNaN(Number(pathSegments[pathSegments.length - 1])) &&
    pathSegments[pathSegments.length - 1]
      ? pathSegments[pathSegments.length - 1]
      : pathSegments[pathSegments.length - 2];

  const pageTitle =
    title || (lastSegment ? lastSegment.replace(/-/g, " ") : "");

  return (
    <div className="flex items-center gap-5">
      {showBack && (
        <button
          onClick={() => (onBack ? onBack() : navigate(-1))}
          className="text-neutral-400 hover:text-neutral-600 transition"
        >
          <img src={back} alt="back" />
        </button>
      )}
      <span className="text-[20px] xl:text-[28px] uppercase font-semibold text-neutral-400">
        {pageTitle}
      </span>
    </div>
  );
}
